import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackCouponCodeFailure = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackCouponCodeFailureEvent = useCallback(
    (couponName) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (couponName) {
          window.webengage.track("coupon_code_failed", {
            couponName,
          });
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackCouponCodeFailureEvent };
};

export default useTrackCouponCodeFailure;
